const edtDynamicCheckEn = {
	edtDynamicCheckTable: 'EDT Dynamic Check',
	edtDynamicCheckEditForm: 'EDT Dynamic Check',
	edtDynamicCheckLog: 'EDT Dynamic Check Log',
	basic: 'Basic',
	disturbanceVariables: 'Disturbance Variables',
	setPoints: 'Set Points',
	sequenceFinishedTags: 'Sequence Finished Tags',
	variablesToMonitor: 'Variables To Monitor',
	alarmVariables: 'Alarm Variables',
	sigma: 'Sigma',
	name: 'Name',
	modelName: 'Model Name',
	log: 'Log',
	sequenceStartItemId: 'Sequence Start Item Id',
	readInterval: 'Read Interval',
	timeWindow: 'Time Window',
	maxIterations: 'Max Iterations',
	itemId: 'Item Id',
	value: 'Value',
	minSampleCountForVarianceCheck: 'Min. Sample Count for Variance Check',
	hostName: 'Host Name',
	serverName: 'Server Name',
};

export default edtDynamicCheckEn;